var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"img-container"},[_c('img',{ref:"image",attrs:{"src":_vm.src,"height":"auto","width":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }